const storeToken = (value) => {
  sessionStorage.setItem("access_token", value);
};

const getToken = () => {
  let access_token = sessionStorage.getItem("access_token");
  return { access_token };
};

const paymentdata = (value) => {
  sessionStorage.setItem("payment_details", JSON.stringify(value));
  console.log(value);
};

const getpaymentdata = () => {
  let payment_details = JSON.parse(sessionStorage.getItem("payment_details"));
  return { payment_details };
};

const removeToken = () => {
  sessionStorage.clear();
  localStorage.clear();
};

const setProfile = (value) => {
  sessionStorage.setItem("profile", JSON.stringify(value));
};

const getProfile = () => {
  let profile = "";

  if (sessionStorage.getItem("profile") !== null) {
    profile = JSON.parse(sessionStorage.getItem("profile"));
  }
  return { profile };
};

export {
  storeToken,
  getToken,
  removeToken,
  setProfile,
  getProfile,
  paymentdata,
  getpaymentdata,
};
